import { useEffect, useState } from 'react';
import { NAV_LINKS } from '@/pages/home/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled;

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-none'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-xl font-black tracking-tight ${
                solid ? 'text-foreground-950' : 'text-white'
              }`}
            >
              抖阴黑料
            </span>
            <span
              className={`mt-1 text-[11px] tracking-[0.2em] ${
                solid ? 'text-primary-600' : 'text-white/80'
              }`}
            >
              GOSSIP DAILY
            </span>
          </span>
        </a>

        {/* center nav */}
        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                solid
                  ? 'text-foreground-800 hover:bg-background-100 hover:text-primary-700'
                  : 'text-white/85 hover:bg-white/10 hover:text-white'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* right actions */}
        <div className="flex items-center gap-2 md:gap-3">
          <a
            href="#hot"
            aria-label="搜索塌房关键词"
            className={`hidden h-10 w-10 items-center justify-center rounded-full transition-colors sm:flex ${
              solid
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-white hover:bg-white/10'
            }`}
          >
            <i className="ri-search-line text-xl" />
          </a>
          <a
            href="#hot"
            className={`inline-flex h-10 items-center gap-1.5 rounded-md px-4 text-sm font-semibold whitespace-nowrap transition-colors ${
              solid
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            <i className="ri-fire-fill" />
            今日塌房
          </a>
          {/* mobile menu button */}
          <a
            href="#top"
            aria-label="菜单"
            className={`flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
              solid ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className="ri-menu-3-line text-xl" />
          </a>
        </div>
      </div>
    </header>
  );
}